import React from 'react';
import { motion } from 'framer-motion';
interface ServicePageHeroProps {
  title: string;
  subtitle: string;
  bgImage: string;
}
export function ServicePageHero({
  title,
  subtitle,
  bgImage
}: ServicePageHeroProps) {
  return <div className="relative py-24 bg-brand-dark overflow-hidden" data-id="element-184">
      <div className="absolute inset-0" data-id="element-185">
        <img src={bgImage} alt={title} className="w-full h-full object-cover opacity-20" data-id="element-186" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark to-brand-dark/50" data-id="element-187"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-188">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-6xl font-heading font-extrabold text-white mb-6" data-id="element-189">
          {title}
        </motion.h1>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-190">
          {subtitle}
        </motion.p>
      </div>
    </div>;
}